export default __webpack_public_path__ + "static/media/nodiWorker.20627370.png";